'use client';

import ProTop from '@/components/Common/ProTop';
import NavbarMobile from './NavbarMobile';
import NavbarDesktop from '@/components/Layouts/Default/Partials/Navbar/NavbarDesktop';
import useAuth from '@/hooks/useAuth';
import { usePlan } from '@/features/subscription/hooks/usePlan';

const Navbar = () => {
  const { user, nextAuthSession, loading } = useAuth();
  const { planIsActive, plan, planIsLoading } = usePlan();

  return (
    <>
      {/* {!planIsLoading && !planIsActive && user && !loading && (
        <ProTop status={plan?.status} />
      )} */}
      <div className="block lg:hidden">
        <NavbarMobile />
      </div>

      <div className="hidden lg:block">
        <NavbarDesktop />
      </div>
    </>
  );
};

export default Navbar;
